import { ajax as jqueryAjax } from "jquery";

// export jquery ajax wrapped in promise
// helpful to have standards compliant promise
// this can likely be removed once we upgrade to jquery 3.x.x
export const ajax = (params) => Promise.resolve(jqueryAjax(params));

export const abortable = (fn) => {
  // this function generates a function
  // that aborts previous, in-progress ajax calls
  let ajaxCall,
      abortableAjax = (params) => {
        if (ajaxCall)
          ajaxCall.abort();

        ajaxCall = jqueryAjax(params);

        return Promise.resolve(ajaxCall);
      };

  return fn(abortableAjax);
};



// WEBPACK FOOTER //
// ./srp/scripts/utils/ajax.js